import { useEffect, useState } from "react";
import { Modal } from "../../../../../theme/Component/Modal";
import { CardTaps } from "../../../../../theme/Component/CardTaps";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _AdquisitionItem } from "../../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { IDAdquisitionProject } from "../../../../../erp/AdquisitionProject/AdquisitionProjectSelect";
import { SelectPreparadorCatalog } from "../../../../select/SelectPreparadorCatalog";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { SelectMonths } from "../../../../select/SelectMonths";
import { SelectModalityNewSer } from "../../../../select/SelectModalityNewSer";
import { SelectUnspscID } from "../../../../../admin/configuracion/UnspscID/SelectUnspscID";
import { SelectProjectID } from "../../../../../admin/configuracion/ProjectID/SelectProjectID";
import { AdquisitionArticle } from "../../../../adquisition-setting/AdquisitionArticle";
import { AdquisitionItemBudgetID } from "../../../../AdquisitionItemBudgetID";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { error } from "console";


interface confProps {
    canEdit?: boolean;
    label?: string;
    visualization?: "button" | "textArea";
}

interface Props {
    IDAquisitionItem: number;
    ConfigProps?: confProps;
}


export const AdquisitionItemEditor = ({ IDAquisitionItem, ConfigProps = { visualization: "textArea" } }: Props) => {

    const { instance, bean, setBean, updateCustonBean } = useDataBean(_AdquisitionItem)

    const taps = [
        { id: 0, name: 'Necesidad' },
        { id: 1, name: 'Rubros' },
        { id: 2, name: 'Articulos' },
    ]

    const [indexTap, setIndexTap] = useState(0);
    const [modal, setModal] = useState<any>({ name: "Información de la Necesidad", tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });

    useEffect(() => {
        if (IDAquisitionItem) {
            getItem();
        }
    }, [IDAquisitionItem])

    const getItem = () => {
        instance.getAdquisitionItem(IDAquisitionItem).then(
            (resp) => {
                console.log(resp);
                setBean(resp);
            }
        ).catch(
            err => {
                console.log(err);
                toast.error("No se pudo traer la información solicitada");
            }
        );
    }

    const updateAdquisitionItem = () => {
        updateCustonBean(bean).then(
            (resp) => {
                console.log(resp)
            }
        ).catch(
            error => {
                console.log(error)
                toast.error("No se pudo Actualizar la necesidad")
            }
        );
    }




    return (
        <div className="row">
            {ConfigProps?.visualization == "textArea" &&
                <div className="col-lg-12">
                    {bean.IDAdquisitionItem ?
                        <label>Necesidad</label>
                        :
                        <label>{ConfigProps?.label ?? "Buscar Necesidad"}</label>
                    }
                    <textarea className="form-control" aria-label="Recipient's username"
                        aria-describedby="button-addon2" placeholder='Buscar...'
                        value={bean.Description}
                        onClick={() => { setModal({ ...modal, 'view': true }); }}
                    />
                </div>
            }

            {ConfigProps?.visualization == "button" &&
                <BasicButton eventClick={() => { setModal({ ...modal, 'view': true }); }} icon="ri-eye-line" children={"ver necesidad"} />
            }

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} onSubmitLabel="Seleccionar Necesidad"  >
                    <CardTaps taps={taps} index={indexTap} updateIndex={setIndexTap}>
                        {indexTap == 0 &&
                            <>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Código</label>
                                        <input type="text" className="form-control" value={bean.CodeItem} onChange={(e) => { setBean({ ...bean, "CodeItem": e.target.value }) }} />
                                    </div>
                                    {/* {ListaTypes.length > 0 &&
                                    <div className="col-md-6">
                                    <label>Tipo de Necesidad</label>
                                    <select name="type" className="form-select" value={bean.TypeManagment} onChange={(e) => { setBean({ ...bean, "TypeManagment": parseInt(e.target.value) }) }}>
                                    {ListaTypes.map((item) => {
                                                return (
                                                    <option value={item.DataBeanProperties.Value}>{item.DataBeanProperties.Property}</option>
                                                    )
                                                    })}
                                                    </select>
                                                    </div>
                                                    } */}
                                    {/* convenios */}
                                    {bean.TypeManagment === 101 &&
                                        <div className="col-md-6">
                                            <IDAdquisitionProject idSelector={bean.IDProject} onChange={(e) => { setBean({ ...bean, "IDProject": e }) }} />
                                        </div>
                                    }
                                    <div className="col-md-6">
                                        <SelectPreparadorCatalog idAdquisitionPlanFunctionalID={bean.IDAdquisitionPlanFunctionalID} idSelector={bean.IDFunctionalIDPreparer != null ? bean.IDFunctionalIDPreparer : 0}
                                            onChange={(id: number) => { setBean({ ...bean, "IDFunctionalIDPreparer": id }) }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <InputMoney _label="Valor Estimado" readonly={(bean.IDAdquisitionItem >= 0 && bean.PhaseState == 2)} _value={bean.TotalValue} onChange={(e: any) => { setBean({ ...bean, ['TotalValue']: e }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <SelectMonths idSelector={bean.ExecutionMonth} onChange={(e: number) => { setBean({ ...bean, "ExecutionMonth": e }) }}></SelectMonths>
                                    </div>
                                    <div className="col-md-6">
                                        <label>Meses Estimados</label>
                                        <input type="number" className="form-control" value={bean.EstimatedMonths} onChange={(e) => { setBean({ ...bean, "EstimatedMonths": e.target.value }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <SelectModalityNewSer idSelector={bean.IDHiringModality} onChange={(e) => { setBean({ ...bean, "IDHiringModality": e }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <SelectUnspscID label="Código Principal" renderValue="" onChange={(e) => { setBean({ ...bean, "IDLnUnspscItem": e.IDLn }) }} />
                                    </div>
                                    <div className="col-md-12">
                                        <SelectProjectID projectIDLn={bean.IDLnProjectID} edit={false} onChange={(e: any) => { setBean({ ...bean, "IDLnProjectID": e.IDLn }) }} />
                                    </div>

                                    <div className="col-md-12">
                                        <label >Justificación</label>
                                        <textarea className="form-control" placeholder='Incluya los aspectos legales, procedimentales, funcionales que sustentan la solicitud'
                                            value={bean.Justification != null ? bean.Justification : ''} onChange={(e) => { setBean({ ...bean, "Justification": e.target.value }) }}></textarea>
                                    </div>
                                    <div className="col-md-12">
                                        <label >Objeto de la Necesidad</label>
                                        <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }}></textarea>
                                    </div>
                                </div>
                                {ConfigProps?.canEdit &&
                                    <div className="row mt-4">
                                        <div className="col-md-3 ">
                                            <BasicButton icon="ri-save-line" children={"Guardar"} eventClick={() => { updateAdquisitionItem() }} />
                                        </div>
                                    </div>
                                }
                            </>
                        }
                        {(indexTap == 1 && bean.IDAdquisitionItem) &&
                            <div className="col">
                                <AdquisitionItemBudgetID CanModify={bean.PreparationState} adquisitionItem={bean} iDBudgetIDType={bean.IDBudgetIDType} estimateValue={bean.TotalValue} onChange={getItem} />
                            </div>
                        }
                        {(indexTap == 2 && bean.IDAdquisitionItem) &&
                            <div className="col-md-12">
                                <AdquisitionArticle adquisitionItem={bean} onlyView={!ConfigProps?.canEdit} updateFather={() => { getItem() }} beanItem={bean} />
                            </div>
                        }
                    </CardTaps>
                </Modal>
            </div>
        </div>
    )
};